import type { ComponentType } from "preact";
import { useEffect } from "preact/hooks";
import { useLocation } from "preact-iso";

import { useApiClient } from "#api.js";

export const withAuth = <P extends object>(Component: ComponentType<P>) => {
	const WrappedComponent = (props: P) => {
		const location = useLocation();
		const apiClient = useApiClient();
		useEffect(() => {
			apiClient.checkIfAuthenticated().then(
				(ok) => {
					if (!ok) {
						location.route("/login", true);
					}
				},
				() => {
					location.route("/login", true);
				},
			);
		}, []);
		return <Component {...props} />;
	};
	WrappedComponent.displayName = `WithAuth(${Component.displayName ?? Component.name})`;
	return WrappedComponent;
};
